import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GatewayDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getGatewaysCounts(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/payment/count', options);
  }

  public getGateways(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/payment/all', options);
  }

  public getTransactions(context, lang, udid, datetimeFrom, datetimeTo) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['params'] = { datetimeFrom, datetimeTo };
    return this.http.get(this.BASE_URL + 'private/v2.0/payment/transactionTraces', options);
  }

  public getTransactionsKPI(context, lang, udid, datetimeFrom, datetimeTo) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['params'] = { datetimeFrom, datetimeTo };
    return this.http.get(this.BASE_URL + 'private/v2.0/payment/transactionTraces/kpi', options);
  }

  public getProviders(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/payment/gateways', options);
  }

  public getTypes(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/payment/types', options);
  }

  public getGatewayInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['params'] = { internalId };
    return this.http.get(this.BASE_URL + 'private/v2.0/payment', options);
  }

  public addNewGateway(context, lang, udid, image, active, name, gatewayInternalId, typeInternalId, invoiceprefix, accessOnsite, accessOnline, properties) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { image, active, name, gatewayInternalId, typeInternalId, invoiceprefix, accessOnsite, accessOnline, properties };
    return this.http.post(this.BASE_URL + 'private/v2.0/payment', item, options);
  }

  public updateGatewayStatus(context, lang, udid, active, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { active, internalId };
    return this.http.patch(this.BASE_URL + 'private/v2.0/payment', item, options);
  }

  public updateGatewayImage(context, lang, udid, internalId, image) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, image };
    return this.http.patch(this.BASE_URL + 'private/v2.0/payment', item, options);
  }

  public updateGatewayInfo(context, lang, udid, internalId, active, name, gatewayInternalId, typeInternalId, invoiceprefix, accessOnsite, accessOnline) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, active, name, gatewayInternalId, typeInternalId, invoiceprefix, accessOnsite, accessOnline };
    return this.http.patch(this.BASE_URL + 'private/v2.0/payment', item, options);
  }

  public updateGatewayProperties(context, lang, udid, internalId, properties) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, properties };
    return this.http.patch(this.BASE_URL + 'private/v2.0/payment', item, options);
  }

  public deleteGateway(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    options['body'] = { internalId };
    return this.http.delete(this.BASE_URL + 'private/v2.0/payment', options);
  }
}
